export const PROFILE_PICTURES = [
  "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_21.png",
  "https://cdn.jsdelivr.net/gh/alohe/avatars/png/vibrent_10.png",
  "https://cdn.jsdelivr.net/gh/alohe/avatars/png/teams_5.png",
  "https://cdn.jsdelivr.net/gh/alohe/avatars/png/teams_1.png",
];
